export default __webpack_public_path__ + "static/media/saint-pierre-sur-dives7.7fe251d6.jpg";